import { useContext } from "react";
import useMenuTitle from "../hooks/useMenuTitle";
import MMachineInfo from "../modules/machineInfo/mobile/MMachineInfo";
import { UserContext } from "../contexts/UserContext";
import UpdateMachineInfo from "../modules/machineInfo/UpdateMachineInfo";

function MachineInfo() {
  useMenuTitle("MachineInfo");
  const { userDetails } = useContext(UserContext);
  const { isMobile, userAccessLevel } = userDetails;

  return (
    <>
      {isMobile ? (
        <MMachineInfo />
      ) : userAccessLevel === "Admin" ? (
        <UpdateMachineInfo />
      ) : (
        <p>You do not have permission to update this information.</p>
      )}
    </>
  );
}

export default MachineInfo;
